import {Component, Prop, Vue} from '@/node_modules/nuxt-property-decorator';
import {appModule} from '@/store/app';

import MNavFoot from '@/components/part/share/MNavFoot.vue';

@Component({
    components: {
        MNavFoot,
    }
})
export default class MGlobalFooter extends Vue {


    public get isActive(): any {

        if (this.$nuxt.$route.name == 'index') {

            if(appModule.deviceSize != 'mb'){
                return false;
            }

            return true;
        }
        return true;
    }

    public get deviceSize(): any {
        return appModule.deviceSize;
    }

}
